/** Copy tables for the Manly Teen B.O. Profile. Pure data, no React. */

export type Verdict = "SURFACE" | "EMBEDDED" | "COMPOUNDING";

/** Q3 answer value -> how we name the villain in copy. */
export const BRAND_LABEL: Record<string, string> = {
  oldspice: "Old Spice",
  axe: "Axe",
  dove: "Dove Men",
  natural: "the natural brand",
  whatever: "the wash in the shower",
  noidea: "his current wash",
};

/** Meter position + one-line read for each verdict. Every line names a problem.
 *  Never good news ("early / mild / you caught it in time"), never absolves
 *  ("he's fine"): the parent came here because something is wrong, so the read
 *  validates that, it doesn't reassure it away. Even SURFACE is a problem that
 *  is setting in, not a stage to feel good about. */
export const VERDICT_META: Record<Verdict, { pos: string; line: string }> = {
  SURFACE: {
    pos: "25%",
    line: "Masked and returning. The smell keeps breaking back through because the bacteria survive the wash, and the pattern is setting in.",
  },
  EMBEDDED: {
    pos: "60%",
    line: "Established on his skin and, by now, living in the fabric.",
  },
  COMPOUNDING: {
    pos: "88%",
    line: "The odor and the skin symptoms are now feeding each other.",
  },
};

/** Q2 goal -> the "Plan focus" stat on the result page. */
export const PLAN_FOCUS: Record<string, string> = {
  fresh: "Removing body odor",
  clothes: "His clothes",
  skin: "Clear skin",
  shower: "Easy showers",
  peace: "Hormone safety",
};
